import Axios from 'axios';
import endpoints from '../utils/endpoints';

export const updateRegionsState = async (component, callback = () => {}) => {
  try {
    const res = await Axios.get(endpoints.locations.REGIONS);
    const regions = res.data.regions;

    const uniqueZips = [...new Set(regions.map(region => region.zip))];
    const zips = uniqueZips.map(zip => ({ label: zip, value: zip }));

    const uniqueCommunities = [...new Set(regions.map(region => region.community))].sort();
    const communities = uniqueCommunities.map(community => ({ label: community, value: community }));

    const newState = {
      regions: regions,
      zips: zips,
      allZips: zips,
      communities,
      allCommunities: communities,
      dataLoaded: true
    };

    component.setState(newState, callback);
  } catch (error) {
    console.error('Error loading regions:', error);
    throw error;
  }
};

export const filterZipsOrCommunitiesBySelection = async (component, value, key) => {
  const { regions } = component.state;
  const modifiedKey = key === 'plz' ? 'zip' : 'community';
  const opposingKey = key === 'plz' ? 'community' : 'zip';
  const opposingStateKeyValue = key === 'plz' ? 'ort' : 'plz';
  const opposingStateKeyOptions = key === 'plz' ? 'communities' : 'zips';

  let filteredData = regions.filter(region => value === region[modifiedKey]).map(region => region[opposingKey]);
  const newOptions = [...new Set(filteredData.map(item => ({ label: item, value: item })))];

  component.setState({ [opposingStateKeyOptions]: newOptions }, () => {
    if (newOptions.length === 1) {
      component.setState({ [opposingStateKeyValue]: newOptions[0].value });
    }
  });
};
